import { render } from "./ProductHorizontal.vue?vue&type=template&id=f198636c"
import script from "./ProductHorizontal.vue?vue&type=script&lang=js"
export * from "./ProductHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bahramhasanov/_PHP/bouquet-new-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__